// This file has been partially auto generated. 
// Please don't make any changes to the lenses.
// Feel free to add or remove annotated properties from
// the generator data class. The corresponding lenses 
// will be removed or added on the next run of the 
// lens generator. See below for more details.
package org.solyton.solawi.bid.module.bid.data.bidround

import org.evoleq.optics.Lensify
import org.evoleq.optics.ReadOnly
import org.evoleq.optics.ReadWrite
import org.evoleq.optics.lens.Lens

/**
 * Generator class.
 * Feel free to add or remove annotated properties from
 * the class. Make sure that they are annotated with
 * - @ReadOnly
 * - @ReadWrite
 * If you want that a property-lens will be generated
 * on the next run of the lens generator.
 * If not, just omit the annotation or annotate it with @Ignore.
 */
@Lensify data class BidRoundResults(
    @ReadOnly val bidRoundResults: List<BidResult> = listOf(),
    @ReadWrite val startDownloadOfBidRoundResults: Boolean = false
)

/**
 * Autogenerated ReadOnly Lens.
 * Read [BidRoundResults.bidRoundResults]
 */
@ReadOnly val bidRoundResults: Lens<BidRoundResults, List<BidResult>> by lazy{ Lens(
    get = {whole -> whole.bidRoundResults},
    set = {{it}}
) }
/**
 * Autogenerated Lens.
 * Read and manipulate [BidRoundResults.startDownloadOfBidRoundResults]
 */
@ReadWrite val startDownloadOfBidRoundResults: Lens<BidRoundResults, Boolean> by lazy{ Lens(
    get = {whole -> whole.startDownloadOfBidRoundResults},
    set = {part -> {whole -> whole.copy(startDownloadOfBidRoundResults = part)}}
) }
/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [BidRoundResults.startDownloadOfBidRoundResults]
 */
@ReadWrite fun BidRoundResults.startDownloadOfBidRoundResults(set: Boolean.()->Boolean ): BidRoundResults = copy(startDownloadOfBidRoundResults = set(startDownloadOfBidRoundResults)) 
